import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '@core/services';
import { LayoutState } from '@core/state/shared';
import { ChangePasswordComponent } from '@widgets/change-password/components';
import { BehaviorSubject, finalize } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-change-password-dialog',
  templateUrl: './change-password-dialog.component.html',
  styleUrls: ['./change-password-dialog.component.scss'],
})
export class ChangePasswordDialogComponent {
  @Input()
  public visible: boolean;

  @Output()
  public visibleChange: EventEmitter<boolean> = new EventEmitter();

  public changePasswordForm: FormGroup;
  public loading$ = new BehaviorSubject(false);

  constructor(
    private authService: AuthService,
    public layoutState: LayoutState
  ) {}

  @ViewChild('changePasswordComponent')
  public set changePasswordComponent(
    changePasswordComponent: ChangePasswordComponent | null
  ) {
    if (changePasswordComponent) {
      this.changePasswordForm = changePasswordComponent.form;
    }
  }

  public closeDialog(): void {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  public updatePassword(): void {
    if (!this.changePasswordForm.valid) {
      return;
    }

    this.loading$.next(true);
    this.authService
      .changePassword(this.changePasswordForm.getRawValue())
      .pipe(
        finalize(() => {
          this.loading$.next(false);
        })
      )
      .subscribe(() => {
        this.closeDialog();
      });
  }
}
